import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, CircularProgress, Button } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing your payment...');

  useEffect(() => {
    const orderTrackingId = searchParams.get('order_tracking_id');
    const paymentStatus = searchParams.get('status');

    if (paymentStatus === 'completed' || paymentStatus === 'COMPLETED') {
      setStatus('success');
      setMessage('Payment successful! Your subscription has been upgraded.');
    } else if (paymentStatus === 'cancelled' || paymentStatus === 'CANCELLED' || searchParams.get('payment') === 'cancelled') {
      setStatus('cancelled');
      setMessage('Payment was cancelled. You can try again from the Subscription page.');
    } else if (orderTrackingId) {
      // PesaPal callback - check status
      const checkStatus = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL || 'http://localhost:5006/api'}/payments/pesapal/status/${orderTrackingId}`
          );
          const data = await response.json();
          if (data.status_code === 1 || data.status === 'COMPLETED') {
            setStatus('success');
            setMessage('Payment successful! Your subscription has been upgraded.');
          } else {
            setStatus('pending');
            setMessage('Payment is being processed. You will receive a confirmation shortly.');
          }
        } catch (err) {
          setStatus('pending');
          setMessage('Payment initiated. Check your Subscription page for status updates.');
        }
      };
      checkStatus();
    } else {
      // PayPal return
      setStatus('pending');
      setMessage('Payment processing. Please check your Subscription page for status.');
    }
  }, [searchParams]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        {status === 'processing' && (
          <>
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>{message}</Typography>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
            <Typography variant="h5" gutterBottom>Payment Successful!</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
            <Button variant="contained" onClick={() => navigate('/admin/dashboard')}>
              Go to Dashboard
            </Button>
          </>
        )}

        {status === 'cancelled' && (
          <>
            <Cancel sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />
            <Typography variant="h5" gutterBottom>Payment Cancelled</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
            <Button variant="contained" onClick={() => navigate('/admin/dashboard')}>
              Back to Dashboard
            </Button>
          </>
        )}

        {status === 'pending' && (
          <>
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>Payment Pending</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
            <Button variant="contained" onClick={() => navigate('/admin/dashboard')}>
              Go to Dashboard
            </Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default PaymentCallback;
